import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import {BioentityChip} from 'ui-library/chips/BioentityChip';
import {ChipSize} from 'ui-library/chips/Chip';
import Modal from 'ui-library/modals/Modal';

export interface InvalidPartsModalProps {
  onRequestSubmit: (shouldUnlink: boolean) => void;
  onRequestClose: () => void;
  invalidPartSequenceIds: Array<string>;
}

export default function InvalidPartsModal({
  onRequestSubmit,
  onRequestClose,
  invalidPartSequenceIds,
}: InvalidPartsModalProps): JSX.Element {
  const handleSubmit = (shouldUnlink: boolean): void => {
    onRequestSubmit(shouldUnlink);
  };

  return (
    <Modal
      title="Invalid parts found"
      onRequestClose={onRequestClose}
      onRequestSubmit={(): void => {
        handleSubmit(true);
      }}
      buttons={[
        {
          text: 'Keep parts',
          cancel: true,
          onClick: (): void => {
            handleSubmit(false);
          },
          style: ButtonStyle.TERTIARY_GRAY,
        },
        {
          text: 'Unlink parts',
          submit: true,
          style: ButtonStyle.PRIMARY,
        },
      ]}
    >
      <div>
        <p>The following parts were found to be invalid according to the autofill configuration rules:</p>
        <div style={{marginBottom: '16px'}}>
          {invalidPartSequenceIds.map((partId) => (
            <BioentityChip
              id={partId}
              className={css(styles.partChip)}
              size={ChipSize.SMALL}
              validationExtras={null}
            />
          ))}
        </div>
        <p>Would you like to unlink these invalid parts? This will remove them from the sequence maps.</p>
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  partChip: {
    margin: '4px',
  },
});
